import { Outlet } from 'react-router-dom';
import { DEMO_EMAIL } from 'appConstants';

import Footer from "components/layouts/Footer";
import Header from "components/layouts/Header";
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { getOemDropDown } from '../../services/customer.service';
import { isAuthenticated } from '../../services/auth.service';
import { useEffect, useRef } from 'react';


const Layout = () => {

    const dispatch = useAppDispatch();
    const currentUser = useAppSelector(x => x.authentication.user);
    const authChecked = useRef(false);

    useEffect(() => {
        // Always check on first mount. The server uses cookie auth
        // (.AspNetCore.BCDCentral.ApplicationCookie) which JS can't read
        // (HttpOnly), so we must hit /Authentication/isAuthenticated to
        // discover whether we're logged in. Gating this on localStorage or
        // query params silently breaks cookie-only sessions (e.g. after
        // SSO redirect lands on a clean URL with empty localStorage).
        if (!currentUser && !authChecked.current) {
            authChecked.current = true;
            dispatch(isAuthenticated());
        }
    }, [dispatch, currentUser]);

    useEffect(() => {
        if (currentUser && currentUser.email !== DEMO_EMAIL) {
            dispatch(getOemDropDown());
        }
    }, [dispatch, currentUser])

    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}

export default Layout;
